(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["leiasa-cart-drawer"]) return;
  try {
    
  class LeiasaCartDrawer {
    constructor(el) {
      this.el = el;
      this.body = document.body;
      this.bind();
      this.interceptCartLinks();
      this.interceptAddForms();
      el.__leiasa = this;
    }

    open() {
      this.body.classList.add('leiasa-cart-open');
      this.el.setAttribute('aria-hidden', 'false');
    }
    close() {
      this.body.classList.remove('leiasa-cart-open');
      this.el.setAttribute('aria-hidden', 'true');
    }

    bind() {
      this.el.addEventListener('click', (e) => {
        if (e.target.closest('[data-leiasa-cart-close]')) { this.close(); return; }
        const qty = e.target.closest('[data-leiasa-qty]');
        if (qty) { e.preventDefault(); this.handleQty(qty); return; }
        const rem = e.target.closest('[data-leiasa-remove]');
        if (rem) { e.preventDefault(); this.handleRemove(rem); return; }
        const add = e.target.closest('[data-leiasa-add]');
        if (add) { e.preventDefault(); this.handleAdd(add); return; }
      });
      this.el.addEventListener('change', (e) => {
        const input = e.target.closest('[data-leiasa-qty-input]');
        if (input) this.handleQtyInput(input);
      });
      this.el.addEventListener('keydown', (e) => {
        const input = e.target.closest('[data-leiasa-qty-input]');
        if (input && e.key === 'Enter') { e.preventDefault(); input.blur(); }
      });
      this.el.addEventListener('focusin', (e) => {
        const input = e.target.closest('[data-leiasa-qty-input]');
        if (input) input.select();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.body.classList.contains('leiasa-cart-open')) this.close();
      });
    }

    interceptCartLinks() {
      document.addEventListener('click', (e) => {
        const a = e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
        if (!a || a.dataset.leiasaCartNoIntercept !== undefined) return;
        if (a.closest('[data-leiasa-cart-drawer]')) return;
        e.preventDefault();
        this.open();
      });
    }

    interceptAddForms() {
      document.addEventListener('submit', async (e) => {
        const form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        const action = (form.action || '').toString();
        if (!action.includes('/cart/add')) return;
        if (form.dataset.leiasaCartNoIntercept !== undefined) return;
        e.preventDefault();
        try {
          // En JSON: Shopify valida el stock (con FormData deja pasar más unidades de las disponibles)
          const fd = new FormData(form);
          const item = { id: Number(fd.get('id')), quantity: Math.max(1, parseInt(fd.get('quantity') || '1', 10) || 1) };
          const props = {};
          for (const [k, v] of fd.entries()) {
            const m = k.match(/^properties\[(.+)\]$/);
            if (m && v !== '') props[m[1]] = v;
          }
          if (Object.keys(props).length) item.properties = props;
          if (fd.get('selling_plan')) item.selling_plan = Number(fd.get('selling_plan'));
          const resp = item.id
            ? await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) })
            : await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
          if (resp.status === 422) {
            // Stock insuficiente: Shopify añade lo que queda (o nada). Mostrar carrito + aviso, sin salir de la página.
            const info = await resp.json().catch(() => ({}));
            form.dispatchEvent(new CustomEvent('leiasa:add-error', { bubbles: true, cancelable: true, detail: info }));
            await this.refresh();
            this.open();
            this.notice();
            return;
          }
          if (!resp.ok) throw new Error(await resp.text());
          await this.refresh();
          this.open();
        } catch (err) {
          console.error('[leiasa-cart] add failed', err);
          form.submit();
        }
      }, true);
    }

    async refresh() {
      const url = new URL(window.location.href);
      url.searchParams.set('sections', 'leiasa-cart-drawer');
      const r = await fetch(url.toString());
      const data = await r.json();
      const html = data['leiasa-cart-drawer'];
      if (!html) return;
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const incoming = tmp.querySelector('[data-leiasa-cart-body]');
      const current = this.el.querySelector('[data-leiasa-cart-body]');
      if (incoming && current) current.replaceWith(incoming);
      // Update any external cart counters in the header
      this.syncHeaderCounter();
    }

    async syncHeaderCounter() {
      try {
        const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        const cart = await r.json();
        document.querySelectorAll('.leiasa-header__cart-label, [data-leiasa-cart-count]').forEach((el) => {
          el.textContent = el.textContent.replace(/\(\d+\)/, '(' + cart.item_count + ')');
        });
        document.querySelectorAll('.leiasa-header__cart-dot').forEach((d) => {
          d.style.display = cart.item_count > 0 ? '' : 'none';
        });
      } catch {}
    }

    async handleQty(btn) {
      const line = parseInt(btn.dataset.line, 10);
      const current = parseInt(btn.dataset.current, 10);
      const delta = btn.dataset.leiasaQty === 'inc' ? 1 : -1;
      const next = Math.max(0, current + delta);
      await this.change(line, next);
    }
    async handleQtyInput(input) {
      const line = parseInt(input.dataset.line, 10);
      const current = parseInt(input.dataset.current, 10);
      const raw = parseInt(input.value, 10);
      const next = isNaN(raw) ? current : Math.max(0, raw);
      if (next === current) { input.value = current; return; }
      await this.change(line, next);
    }
    async handleRemove(btn) {
      const line = parseInt(btn.dataset.line, 10);
      await this.change(line, 0);
    }
    async handleAdd(btn) {
      const id = btn.dataset.id;
      if (!id) return;
      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 }),
      });
      await this.refresh();
      if (resp.status === 422) this.notice();
    }
    async change(line, quantity) {
      const resp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity }),
      });
      await this.refresh();
      if (resp.status === 422) { this.notice(); return; }
      // Shopify recorta la cantidad al stock disponible sin dar error: avisar si se quedó corta
      if (resp.ok && quantity > 0) {
        const cart = await resp.json().catch(() => null);
        const item = cart && cart.items && cart.items[line - 1];
        if (item && item.quantity < quantity) this.notice();
      }
    }
    // Aviso breve dentro del carrito (stock insuficiente). Texto localizado en data-msg-nostock.
    notice() {
      const msg = this.el.dataset.msgNostock;
      const body = this.el.querySelector('[data-leiasa-cart-body]');
      if (!msg || !body) return;
      let n = body.querySelector('.leiasa-cart__notice');
      if (!n) {
        n = document.createElement('p');
        n.className = 'leiasa-cart__notice';
        n.setAttribute('role', 'status');
        const header = body.querySelector('.leiasa-cart__header');
        if (header) header.after(n); else body.prepend(n);
      }
      n.textContent = msg;
      clearTimeout(this._noticeTimer);
      this._noticeTimer = setTimeout(() => n.remove(), 6000);
    }
  }

  function leiasaInitCart() {
    const el = document.querySelector('[data-leiasa-cart-drawer]');
    if (el && !el.__leiasa) new LeiasaCartDrawer(el);
  }
  document.addEventListener('DOMContentLoaded', leiasaInitCart);
  if (document.readyState !== 'loading') leiasaInitCart();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leiasa-header"] && !Shopify.designMode) return;
  try {
    
  /* Mobile menu drawer */
  (function () {
    function initMobileMenu() {
      const drawer = document.querySelector('[data-mobile-menu]');
      if (!drawer || drawer.__leiasaInit) return;
      drawer.__leiasaInit = true;
      const openBtns = document.querySelectorAll('[data-mobile-menu-open]');
      const closeBtns = drawer.querySelectorAll('[data-mobile-menu-close]');
      function open() {
        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('leiasa-mobile-menu-open');
        openBtns.forEach(b => b.setAttribute('aria-expanded', 'true'));
      }
      function close() {
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('leiasa-mobile-menu-open');
        openBtns.forEach(b => b.setAttribute('aria-expanded', 'false'));
      }
      openBtns.forEach(b => b.addEventListener('click', open));
      closeBtns.forEach(b => b.addEventListener('click', close));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
      });
      // Cierra el drawer al navegar a un link interno
      drawer.querySelectorAll('a[href]').forEach((a) => {
        a.addEventListener('click', () => { setTimeout(close, 50); });
      });
    }
    if (document.readyState !== 'loading') initMobileMenu();
    else document.addEventListener('DOMContentLoaded', initMobileMenu);
  })();

  (function () {
    function init() {
      const items = document.querySelectorAll('.leiasa-header__nav-item.has-submenu');
      items.forEach((item) => {
        const trigger = item.querySelector('.leiasa-header__nav-link');
        if (!trigger) return;
        // En touch, el primer tap abre el submenú; el segundo navega
        trigger.addEventListener('click', (e) => {
          if (!matchMedia('(hover: none)').matches) return;
          if (!item.classList.contains('is-open')) {
            e.preventDefault();
            items.forEach((i) => i !== item && i.classList.remove('is-open'));
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
          }
        });
      });
      // Cerrar al click fuera
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.leiasa-header__nav-item.has-submenu')) {
          items.forEach((i) => {
            i.classList.remove('is-open');
            const t = i.querySelector('.leiasa-header__nav-link');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
        }
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  (function () {
    const RECENT_KEY = 'leiasa_recent_searches_v1';
    const MAX_RECENT = 6;

    function initSearch() {
      const overlay = document.querySelector('[data-search-overlay]');
      if (!overlay) return;
      const openBtns = document.querySelectorAll('[data-search-open]');
      const closeBtn = overlay.querySelector('[data-search-close]');
      const form = overlay.querySelector('[data-leiasa-search]');
      const input = overlay.querySelector('[data-search-input]');
      const clearBtn = overlay.querySelector('[data-search-clear]');
      const kbdHint = overlay.querySelector('.leiasa-search__kbd');
      const recentWrap = overlay.querySelector('[data-search-recent]');
      const recentList = overlay.querySelector('[data-recent-list]');
      const resultsBox = overlay.querySelector('[data-search-results]');
      const productsList = overlay.querySelector('[data-products-list]');
      const collectionsBlock = overlay.querySelector('[data-results-collections]');
      const collectionsList = overlay.querySelector('[data-collections-list]');
      const pagesBlock = overlay.querySelector('[data-results-pages]');
      const pagesList = overlay.querySelector('[data-pages-list]');
      const seeAll = overlay.querySelector('[data-see-all]');
      const countEl = overlay.querySelector('[data-results-count]');
      const emptyBlock = overlay.querySelector('[data-results-empty]');
      const emptyQuery = overlay.querySelector('[data-empty-query]');
      const sideWrap = overlay.querySelector('[data-results-side]');

      let timer, ctrl, activeIndex = -1, navItems = [];

      // ---------- helpers ----------
      function esc(s) {
        return String(s).replace(/[&<>"']/g, (c) => ({
          '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
      }
      function fmtPrice(p) {
        if (p === null || p === undefined || p === '') return '';
        const n = typeof p === 'number' ? p : parseFloat(p);
        if (isNaN(n)) return '';
        return n.toLocaleString('es-ES', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 });
      }
      function normalize(s) {
        return String(s).toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
      }
      function highlight(text, q) {
        const safe = esc(text);
        if (!q) return safe;
        const tokens = q.trim().split(/\s+/).filter((t) => t.length >= 2).map(normalize);
        if (!tokens.length) return safe;
        const normSafe = normalize(safe);
        const ranges = [];
        tokens.forEach((tok) => {
          let i = 0;
          while ((i = normSafe.indexOf(tok, i)) !== -1) {
            ranges.push([i, i + tok.length]);
            i += tok.length;
          }
        });
        if (!ranges.length) return safe;
        ranges.sort((a, b) => a[0] - b[0]);
        const merged = [];
        ranges.forEach((r) => {
          if (merged.length && r[0] <= merged[merged.length - 1][1]) {
            merged[merged.length - 1][1] = Math.max(merged[merged.length - 1][1], r[1]);
          } else merged.push(r.slice());
        });
        let out = '', pos = 0;
        merged.forEach(([a, b]) => {
          out += safe.slice(pos, a) + '<mark>' + safe.slice(a, b) + '</mark>';
          pos = b;
        });
        out += safe.slice(pos);
        return out;
      }

      // ---------- recientes ----------
      function getRecent() {
        try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); }
        catch (e) { return []; }
      }
      function setRecent(arr) {
        try { localStorage.setItem(RECENT_KEY, JSON.stringify(arr.slice(0, MAX_RECENT))); } catch (e) {}
      }
      function addRecent(q) {
        q = (q || '').trim();
        if (!q || q.length < 2) return;
        const cur = getRecent().filter((x) => normalize(x) !== normalize(q));
        cur.unshift(q);
        setRecent(cur);
      }
      function renderRecent() {
        if (!recentList || !recentWrap) return;
        const items = getRecent();
        if (!items.length) { recentWrap.hidden = true; return; }
        recentWrap.hidden = false;
        recentList.innerHTML = items.map((q) =>
          '<button type="button" class="leiasa-search-overlay__recent-chip" data-recent-q="' + esc(q) + '">'
            + '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8v4l3 2"/></svg>'
            + '<span>' + esc(q) + '</span>'
          + '</button>'
        ).join('') + '<button type="button" class="leiasa-search-overlay__recent-clear" data-recent-clear>Borrar historial</button>';
      }
      function clearRecent() { setRecent([]); renderRecent(); }

      // ---------- abrir / cerrar ----------
      function open() {
        overlay.hidden = false;
        void overlay.offsetWidth;
        overlay.setAttribute('aria-hidden', 'false');
        openBtns.forEach((b) => b.setAttribute('aria-expanded', 'true'));
        renderRecent();
        setTimeout(() => input && input.focus(), 60);
      }
      function close() {
        overlay.setAttribute('aria-hidden', 'true');
        openBtns.forEach((b) => b.setAttribute('aria-expanded', 'false'));
        if (input) input.value = '';
        if (clearBtn) clearBtn.hidden = true;
        if (kbdHint) kbdHint.hidden = false;
        overlay.classList.remove('is-querying', 'is-loading');
        if (resultsBox) resultsBox.hidden = true;
        if (productsList) productsList.innerHTML = '';
        if (collectionsList) collectionsList.innerHTML = '';
        if (pagesList) pagesList.innerHTML = '';
        if (emptyBlock) emptyBlock.hidden = true;
        activeIndex = -1; navItems = [];
        setTimeout(() => { overlay.hidden = true; }, 220);
      }

      openBtns.forEach((b) => b.addEventListener('click', (e) => { e.stopPropagation(); open(); }));
      if (closeBtn) closeBtn.addEventListener('click', close);
      document.addEventListener('click', (e) => {
        if (overlay.getAttribute('aria-hidden') !== 'false') return;
        if (e.target.closest('[data-search-overlay]') || e.target.closest('[data-search-open]')) return;
        close();
      });

      // ---------- atajos teclado globales ----------
      document.addEventListener('keydown', (e) => {
        const isOpen = overlay.getAttribute('aria-hidden') === 'false';
        const tag = (e.target.tagName || '').toLowerCase();
        const inField = tag === 'input' || tag === 'textarea' || tag === 'select' || e.target.isContentEditable;
        if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
          e.preventDefault();
          if (isOpen) close(); else open();
          return;
        }
        if (!isOpen && e.key === '/' && !inField) {
          e.preventDefault(); open(); return;
        }
        if (!isOpen) return;
        if (e.key === 'Escape') { e.preventDefault(); close(); return; }
        if (e.key === 'ArrowDown') { e.preventDefault(); moveActive(1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); moveActive(-1); }
        else if (e.key === 'Enter' && activeIndex >= 0 && navItems[activeIndex]) {
          e.preventDefault();
          addRecent(input ? input.value : '');
          window.location.href = navItems[activeIndex].getAttribute('href');
        }
      });

      function collectNavItems() {
        navItems = Array.from(overlay.querySelectorAll('[data-nav-item]'));
        activeIndex = -1;
      }
      function moveActive(dir) {
        if (!navItems.length) return;
        activeIndex = (activeIndex + dir + navItems.length) % navItems.length;
        navItems.forEach((el, i) => {
          el.classList.toggle('is-active', i === activeIndex);
          if (i === activeIndex) el.scrollIntoView({ block: 'nearest' });
        });
      }

      if (form) {
        form.addEventListener('submit', () => addRecent(input ? input.value : ''));
      }

      function updateClearBtn() {
        const hasVal = !!(input && input.value.length > 0);
        if (clearBtn) clearBtn.hidden = !hasVal;
        if (kbdHint) kbdHint.hidden = hasVal;
      }
      if (clearBtn) {
        clearBtn.addEventListener('click', () => {
          if (!input) return;
          input.value = '';
          input.focus();
          updateClearBtn();
          runQuery();
        });
      }

      if (recentList) {
        recentList.addEventListener('click', (e) => {
          const chip = e.target.closest('[data-recent-q]');
          if (chip && input) {
            input.value = chip.getAttribute('data-recent-q');
            updateClearBtn();
            runQuery();
            input.focus();
            return;
          }
          if (e.target.closest('[data-recent-clear]')) clearRecent();
        });
      }

      // ---------- render ----------
      function renderProducts(products, q) {
        if (!productsList) return;
        productsList.innerHTML = products.map((p) => {
          const img = p.image
            ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="120" height="120">'
            : '';
          const priceNum = (typeof p.price === 'number') ? p.price : parseFloat(p.price);
          const priceFmt = isFinite(priceNum) ? fmtPrice(priceNum) : '';
          return '<a class="leiasa-search-overlay__product" data-nav-item href="' + esc(p.url) + '">'
            + '<div class="leiasa-search-overlay__product-media">' + img + '</div>'
            + '<div class="leiasa-search-overlay__product-body">'
              + '<div class="leiasa-search-overlay__product-head">'
                + '<span class="leiasa-search-overlay__product-title">' + highlight(p.title, q) + '</span>'
                + (priceFmt ? '<span class="leiasa-search-overlay__product-price">' + esc(priceFmt) + '</span>' : '')
              + '</div>'
              + (p.vendor ? '<span class="leiasa-search-overlay__product-meta">' + esc(p.vendor) + '</span>' : '')
            + '</div>'
          + '</a>';
        }).join('');
      }
      function renderCollections(cols, q) {
        if (!collectionsBlock || !collectionsList) return;
        if (!cols.length) { collectionsBlock.hidden = true; return; }
        collectionsBlock.hidden = false;
        collectionsList.innerHTML = cols.map((c) =>
          '<li><a class="leiasa-search-overlay__topic" data-nav-item href="' + esc(c.url) + '">' + highlight(c.title, q) + '</a></li>'
        ).join('');
      }
      function renderPages(items, q) {
        if (!pagesBlock || !pagesList) return;
        if (!items.length) { pagesBlock.hidden = true; return; }
        pagesBlock.hidden = false;
        pagesList.innerHTML = items.map((p) =>
          '<li><a class="leiasa-search-overlay__page-link" data-nav-item href="' + esc(p.url) + '">' + highlight(p.title, q) + '</a></li>'
        ).join('');
      }

      // ---------- query ----------
      async function runQuery() {
        if (!input) return;
        const q = input.value.trim();
        updateClearBtn();

        if (q.length === 0) {
          overlay.classList.remove('is-querying', 'is-loading');
          if (resultsBox) resultsBox.hidden = true;
          if (emptyBlock) emptyBlock.hidden = true;
          renderRecent();
          return;
        }

        overlay.classList.add('is-querying', 'is-loading');
        if (resultsBox) resultsBox.hidden = false;
        if (recentWrap) recentWrap.hidden = true;
        if (emptyBlock) emptyBlock.hidden = true;
        if (sideWrap) sideWrap.hidden = false;

        if (ctrl) ctrl.abort();
        ctrl = new AbortController();

        try {
          const url = '/search/suggest.json'
            + '?q=' + encodeURIComponent(q)
            + '&resources[type]=product,collection,page,article'
            + '&resources[limit]=10'
            + '&resources[options][unavailable_products]=last'
            + '&resources[options][fields]=title,product_type,variants.title,vendor,tag,body';
          const r = await fetch(url, { signal: ctrl.signal });
          if (!r.ok) { overlay.classList.remove('is-loading'); return; }
          const data = await r.json();
          const res = (data.resources && data.resources.results) || {};
          const products = (res.products || []).map((p) => ({
            url: p.url, title: p.title,
            image: (p.featured_image && (p.featured_image.url || p.featured_image)) || p.image || '',
            price: p.price,
            vendor: p.vendor
          }));
          const collections = (res.collections || []).slice(0, 5).map((c) => ({ url: c.url, title: c.title }));
          const pages = ((res.pages || []).concat(res.articles || [])).slice(0, 4).map((x) => ({ url: x.url, title: x.title }));

          renderProducts(products, q);
          renderCollections(collections, q);
          renderPages(pages, q);

          if (countEl) countEl.textContent = products.length ? '(' + products.length + ')' : '';

          if (products.length === 0 && collections.length === 0 && pages.length === 0) {
            if (emptyBlock) { emptyBlock.hidden = false; if (emptyQuery) emptyQuery.textContent = q; }
            if (seeAll) seeAll.hidden = true;
            if (sideWrap) sideWrap.hidden = true;
          } else {
            if (sideWrap) sideWrap.hidden = (collections.length === 0 && pages.length === 0);
            if (seeAll) {
              seeAll.hidden = false;
              seeAll.setAttribute('href', '/search?q=' + encodeURIComponent(q) + '&type=product');
            }
          }
          collectNavItems();
        } catch (e) { /* abort */ }
        finally { overlay.classList.remove('is-loading'); }
      }

      if (input) {
        input.addEventListener('input', () => {
          clearTimeout(timer);
          updateClearBtn();
          timer = setTimeout(runQuery, 140);
        });
        input.addEventListener('focus', updateClearBtn);
      }
    }

    if (document.readyState !== 'loading') initSearch();
    else document.addEventListener('DOMContentLoaded', initSearch);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
